
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

import { Platform, AlertController } from '@ionic/angular';
import { Router } from '@angular/router';
import { BaseInjectorService } from 'src/app/base/base-service.injector';

@Injectable({
  providedIn: 'root'
})
export class BackButtonService extends BaseInjectorService{

  constructor(
    public platform: Platform,
    // private splashScreen: SplashScreen,
    private _location: Location,
    public alertController: AlertController

  ) {
  super()
  }

  public registerAllEvents() {
    this.register();
  }

  private register() {
    this.platform.backButton.subscribeWithPriority(10, (processNextHandler) => {
      // if (this._location.isCurrentPathEqualTo('/dashboard') || this._location.isCurrentPathEqualTo('/achievements') || this._location.isCurrentPathEqualTo('/action-management') || this._location.isCurrentPathEqualTo('/treasure-hunt-team-selection')|| this._location.isCurrentPathEqualTo('/more')) {
      //   // Show Exit Alert!
      //   this.showExitConfirm();
      //   processNextHandler();
      // }else {
      //   // Navigate to back page
      //   this._location.back();
      // }
    });

    this.platform.backButton.subscribeWithPriority(5, () => {
      this.alertController.getTop().then(r => {
        if (r) {
          navigator['app'].exitApp();
        }
      }).catch(e => {
        console.log(e);
      })
    });
  }

  showExitConfirm() {
    
    this.alertController.create({
      header: this.translate.instant("APP_TERMINATION"),
      message: this.translate.instant("DO_YOU_WANT_TO_CLOSE_THE_APP"),
      backdropDismiss: false,
      cssClass: "abort-alert",
      buttons: [{
        text: this.translate.instant("APP_STAY"),
        role: 'cancel',
        handler: () => {
          console.log('Application exit prevented!');
        }
      }, {
        text: this.translate.instant("TREASURE_HUNT.EXIT"),
        role: 'ok',
        handler: () => {
          navigator['app'].exitApp();
        }
      }]
    })
    // .then(alert => {
    //     alert.present();
    //   });
  }



}
